import { ZERO, type Decimal } from '../core/decimal.ts';
import type { Series } from '../types/domain.ts';

export interface YearlySample {
  readonly year: number;
  readonly value: Decimal;
}

/**
 * PaymentBucket.yearlySamples: year 0 is the first bucket (0 when empty); year y is bucket
 * 12y − 1, clamped to the last bucket.
 */
export function yearlySamples(series: Series, years: number): readonly YearlySample[] {
  const samples: YearlySample[] = [{ year: 0, value: series[0]?.amount ?? ZERO }];
  for (let year = 1; year <= years; year++) {
    const bucket = series[Math.min(year * 12 - 1, series.length - 1)];
    if (bucket !== undefined) samples.push({ year, value: bucket.amount });
  }
  return samples;
}
